import React from 'react';
import PropTypes from 'prop-types';

import {concatUrl} from '../helpers/url';
import {postCall} from '../helpers/request';
import GlobalContext from '../helpers/context';
import ActionButton from '../component/atoms/ActionButton';


class CurationProfileIgnoreButton extends React.Component {

    constructor(props) {
        super(props);

        this.ignore_profile_url = concatUrl(window.ROOT_URL, 'api', 'curation_profile', 'ignore');
    }

    stopPropagation = (event) => {
        event.stopPropagation();
    };

    onDialogCancel = (event) => {
        this.stopPropagation(event);
    };

    // +++ ignore profile +++++++++++++++++++++++++++++++++++++++++++++++

    ignoreProfileFailed = () => {
        this.context.displayGlobalError('Backend service failure: Could not ignore the profile.');
    };

    ignoreProfileDone = () => {
        this.context.displayGlobalInfo('Profile will be ignored from now on');
        if(this.props.doneCallback){
            this.props.doneCallback(this.props.profile.profile_id);
        }
    };

    ignoreProfile = (event) => {
        this.stopPropagation(event);
        const data = {
            curation_profile_id: this.props.curation_profile_id,
            ignore_profile_id: this.props.profile.profile_id,
            workspace_id: this.props.workspace_id
        };
        postCall(this.ignore_profile_url, data, this.ignoreProfileDone, this.ignoreProfileFailed);
    };

    showIgnoreConfirmationDialog = (event) => {
        this.stopPropagation(event);

        this.context.showConfirmationDialog({
            confirm_dialog_on_close: this.onDialogCancel,
            confirm_dialog_on_confirm: this.ignoreProfile,
            confirm_dialog_title: 'Please confirm',
            confirm_dialog_text: `Are you sure you want to ignore the profile "${this.props.profile.full_name}" (${this.props.profile.researcher_id}) from now on in this curation profile?`,
            confirm_dialog_button_text: 'ignore'
        });
    };

    render() {
        return (
            <GlobalContext.Consumer>{() => (
                <ActionButton
                    text="Ignore"
                    linkStyle={true}
                    actionCallback={this.showIgnoreConfirmationDialog}
                />
            )}
            </GlobalContext.Consumer>
        );
    }
}

CurationProfileIgnoreButton.contextType = GlobalContext;

CurationProfileIgnoreButton.propTypes = {
    curation_profile_id: PropTypes.number.isRequired,
    workspace_id: PropTypes.number.isRequired,
    profile: PropTypes.object.isRequired,
    doneCallback: PropTypes.func
};

export default CurationProfileIgnoreButton;
